import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";

export function KanbanLanesFilter({ onFiltered }) {
  const [lanes, setLanes] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await api.get("/tag/kanban/");
        const semEtiqueta = { id: 0, name: 'Sem Etiqueta', color: '#757575' };
        // Mantem o fluxo ativo oculto, mas permite localizar os atendimentos
        // que terminaram no kanban de sem sucesso.
        const allLanes = (data.lista || data.list || []).filter(
          lane => !lane.isSystem || ["Sem Sucesso", "Sem Sucesso Follow Up Estratiza"].includes(lane.name)
        );
        setLanes([semEtiqueta, ...allLanes]);
      } catch (err) {
        toastError(err);
      }
    }
    fetchData();
  }, []);

  const onChange = (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box style={{ padding: 10 }}>
      <Autocomplete
        multiple
        size="small"
        options={lanes}
        value={selecteds}
        onChange={(e, v) => onChange(v)}
        getOptionLabel={(option) => option.name}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{
                backgroundColor: option.color || "#7c4dff",
                textShadow: "1px 1px 1px #000",
                color: "white",
              }}
              label={option.name}
              {...getTagProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Filtro por Coluna Kanban"
          />
        )}
      />
    </Box>
  );
}
